"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
const AppVersionEntity_1 = require("../app-versions/AppVersionEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const BinaryDto_1 = require("./BinaryDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class BinaryEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, binary) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            appVersionId: false,
            binaryType: false,
            flurryApiKey: false,
            bugSenseApiKey: false
        };
        this._dependencies = dependencies;
        if (binary === undefined) {
            this._dto = new BinaryDto_1.BinaryDto();
        }
        else if (binary instanceof BinaryDto_1.BinaryDto) {
            this._dto = new BinaryDto_1.BinaryDto(binary);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (binary instanceof BinaryEntity) {
            this._dto = new BinaryDto_1.BinaryDto(binary._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new BinaryDto_1.BinaryDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getAppVersion() {
        if (this._dto.appVersionId === undefined) {
            return undefined;
        }
        if (this._dto.appVersion === undefined) {
            throw new Error("Cannot call getAppVersion without first loading the App Version.");
        }
        if (!this._appVersionEntity && this._dto.appVersion) {
            this._appVersionEntity = new AppVersionEntity_1.AppVersionEntity(this._dependencies, this._dto.appVersion);
        }
        return this._appVersionEntity;
    }
    getAppVersionId() {
        return this._dto.appVersionId;
    }
    setAppVersion(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppVersionEntity_1.AppVersionEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppVersionDto_1.AppVersionDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppVersionId(untrustedId);
        if (this.hasError("appVersionId")) {
            return;
        }
        if (untrustedValue instanceof AppVersionEntity_1.AppVersionEntity) {
            this._appVersionEntity = untrustedValue;
        }
    }
    setAppVersionId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appVersionId");
        this._requiredFieldsSetStatus.appVersionId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appVersionId", "App Version Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appVersionId", "App Version is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appVersionId) {
            return;
        }
        this._dto.appVersionId = _untrustedValue;
        delete this._appVersionEntity;
        this._setIsDirty(true);
    }
    getBinaryType() {
        return this._dto.binaryType;
    }
    setBinaryType(untrustedValue) {
        const maxLength = 12;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("binaryType");
        this._requiredFieldsSetStatus.binaryType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("binaryType", "Binary Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("binaryType", `Binary Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.binaryType) {
            return;
        }
        this._dto.binaryType = _untrustedValue;
        this._setIsDirty(true);
    }
    getFlurryApiKey() {
        return this._dto.flurryApiKey;
    }
    setFlurryApiKey(untrustedValue) {
        const maxLength = 25;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("flurryApiKey");
        this._requiredFieldsSetStatus.flurryApiKey = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("flurryApiKey", "Flurry Api Key is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("flurryApiKey", `Flurry Api Key has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.flurryApiKey) {
            return;
        }
        this._dto.flurryApiKey = _untrustedValue;
        this._setIsDirty(true);
    }
    getBugSenseApiKey() {
        return this._dto.bugSenseApiKey;
    }
    setBugSenseApiKey(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("bugSenseApiKey");
        this._requiredFieldsSetStatus.bugSenseApiKey = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("bugSenseApiKey", "Flurry Api Key is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("bugSenseApiKey", `Flurry Api Key has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.bugSenseApiKey) {
            return;
        }
        this._dto.bugSenseApiKey = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAppVersionAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppVersionId()) {
                    return;
                }
                this._emit("before-loadAppVersionAsync");
                this._dto.appVersion = yield this._dependencies.appVersionDatastore
                    .getAsync(this.getAppVersionId(), expand);
                delete this._appVersionEntity;
                this._emit("after-loadAppVersionAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.binaryDatastore
                    .getAsync(id, expand);
                delete this._appEntity;
                delete this._appVersionEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Binary is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.binaryDatastore
                        .addAsync(dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.binaryDatastore
                        .updateAsync(dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Binary cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.binaryDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.BinaryEntity = BinaryEntity;
//# sourceMappingURL=BinaryEntity.js.map